module.exports = __webpack_public_path__ + "static/media/ca-phone-icon.3c8b102c.svg";